export const COURSE_PAUSE_REQUEST_TRACKINGS = {
  coursePauseRequestSort: 'course_pause_request_sort',
} as const;
